export const REFERRER_TYPE_PARTNER = 'partner';
export const REFERRER_TYPE_USER = 'user';
